<template>
  <v-container class="c-content__login fill-height">
    <v-row class="d-flex flex-column justify-center align-center" >  
         <v-btn :color="branding.primaryColor" class="white--text" elevation="16" fab loading x-large></v-btn>
    </v-row>
  </v-container>
</template>

<script>
import branding from "@/config/branding";

export default {
name: 'Loader',
data() {
    return {
        branding
    }
}
}
</script>
<style>
</style>